import { render, staticRenderFns } from "./ButtonCustomizeField.vue?vue&type=template&id=74135750&"
import script from "./ButtonCustomizeField.vue?vue&type=script&lang=ts&"
export * from "./ButtonCustomizeField.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonCustomizeField.vue?vue&type=style&index=0&id=74135750&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports